// extracted by mini-css-extract-plugin
module.exports = {"body":"container-queries_body__qBLmZ","media-wrapper":"container-queries_media-wrapper__wm7yH"};